import React from "react";
import { useRouterContext, TitleProps } from "@pankod/refine-core";
import { Button } from "@pankod/refine-mui";

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  const { Link } = useRouterContext();

  return (
    <Button fullWidth variant="text" disableRipple>
      <Link to="/">
        {collapsed ? (
          <img src="/images/icon.png" alt="Refine" width="30px" />
        ) : (
          <img src="/images/logo.png" alt="Refine" width="120px" />
        )}
      </Link>
    </Button>
  );
};
